import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

export type PillTone =
  | "neutral"
  | "info"
  | "success"
  | "warning"
  | "danger"
  | "accent";

const subtle: Record<PillTone, string> = {
  neutral: "border-neutral-700 bg-neutral-800/60 text-neutral-300",
  info: "border-info-border bg-info-bg text-info-fg",
  success: "border-success-border bg-success-bg text-success-fg",
  warning: "border-warning-border bg-warning-bg text-warning-fg",
  danger: "border-danger-border bg-danger-bg text-danger-fg",
  accent: "border-accent-700/60 bg-accent-900/40 text-accent-300",
};

const solid: Record<PillTone, string> = {
  neutral: "border-neutral-600 bg-neutral-700 text-neutral-100",
  info: "border-info-border bg-info-fg/30 text-info-fg",
  success: "border-success-border bg-success-fg/30 text-success-fg",
  warning: "border-warning-border bg-warning-fg/30 text-warning-fg",
  danger: "border-danger-border bg-danger-fg/30 text-danger-fg",
  accent: "border-accent-500 bg-accent-600 text-neutral-50",
};

export function Pill({
  tone = "neutral",
  variant = "subtle",
  className,
  children,
}: {
  tone?: PillTone;
  variant?: "subtle" | "solid";
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium",
        variant === "subtle" ? subtle[tone] : solid[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
